import I18n from 'I18n';
// @ts-expect-error Untyped module
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import ResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { TextCell } from './TextCells';
import { jsx as _jsx } from "react/jsx-runtime";
const UserCell = ({
  crmObject,
  propertyName
}) => {
  const userIdStr = getPropertyValue(crmObject, propertyName);
  const userId = userIdStr ? parseInt(`${userIdStr}`, 10) : undefined;
  if (!userId || userId === 100) {
    const langKey = `content-management-listing-lib.table.cells.emptyValues.${!userId ? 'author' : 'systemUser'}`;
    return /*#__PURE__*/_jsx(TextCell, {
      value: I18n.text(langKey)
    });
  }
  return /*#__PURE__*/_jsx(ResolvedCell, {
    id: userId,
    objectType: USER
  });
};
export default UserCell;